import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from '../material.module';
import { RecuperaContrasenhaPageRoutingModule } from './recupera-contrasenha-routing.module';
// import { RecaptchaModule } from 'ng-recaptcha';
import { RecuperaContrasenhaPage } from './recupera-contrasenha.page';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RecuperaContrasenhaPageRoutingModule,
    // RecaptchaModule,
    MaterialModule,
    FontAwesomeModule,
    NgxCaptchaModule,
  ],
  declarations: [RecuperaContrasenhaPage]
})
export class RecuperaContrasenhaPageModule { }
